import React from 'react';
import {
  reduxForm,
  Field,
  FieldArray,
  getFormValues,
  isDirty,
} from 'redux-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Select from 'react-select';
import { Link } from 'react-router';

import SettingField from 'components/Fields/ReduxForm/SettingField';
import UploadImage from 'components/Fields/ReduxForm/UploadImage';
import { onCheckedSalesType } from 'actions/businessLibrary/item';

import styles from './ItemForm.css';
import ItemModifier from './ItemModifier';
import ItemVariant from './ItemVariant';

class RenderSelectField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectInstance: 1,
    };
  }

  onChangeSelect = newval => {
    const {
      input: { onChange },
    } = this.props;
    onChange(newval.value);
  };

  render() {
    const {
      input: { value },
      placeholder,
      options,
      disabled,
    } = this.props;

    const selectProps = {
      value,
      className: styles['select-dropdown'],
      placeholder,
      onChange: this.onChangeSelect,
      options,
      disabled,
      clearable: false,
      backspaceRemoves: false,
      onClose: () => {
        this.setState({ selectInstance: 1 - this.state.selectInstance });
      },
    };
    if (this.state.selectInstance === 1) {
      return (
        <div>
          <Select {...selectProps} />
        </div>
      );
    }
    return (
      <span>
        <Select {...selectProps} />
      </span>
    );
  }
}

class ItemForm extends React.Component {
  constructor(props) {
    super(props);
    this.scrollArea = null;
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.mustScrollTop) {
      this.scrollArea.scrollTop = 0;
    }
  }

  render() {
    const { itemDetail, categories, itemForm, salesType } = this.props;
    const uploadImagePlaceholder =
      itemForm && itemForm.name ? itemForm.name.substring(0, 2) : '';

    return (
      <div
        ref={a => {
          this.scrollArea = a;
        }}
        className={`${styles['item-fieldset']} body-form-item`}
      >
        <div className="row">
          <Field component="input" type="hidden" name="id" />
          {/* upload image */}
          <div className="col-lg-3 col-md-3 col-sm-3 no-padding-right item-image-box">
            <Field
              name="image"
              component={UploadImage}
              placeholder={uploadImagePlaceholder}
              className={styles['upload-image']}
              backgroundColor={itemDetail ? itemDetail.background_color : null}
            />
          </div>
          <div
            className={`col-lg-9 col-md-9 col-sm-9 no-padding-left no-padding-right ${
              styles['side-image-wrapper']
            }`}
          >
            {/* item name */}
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <Field
                    component={SettingField}
                    className="form-control"
                    name="name"
                    maxLength="40"
                    placeholder="Item Name"
                    type="text"
                  />
                </div>
              </div>
            </div>

            {/* categories */}
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <Field
                    component={RenderSelectField}
                    className="selectCategories"
                    name="business_level_category_id"
                    disabled={false}
                    options={this._formatCategories(categories)}
                    categories={categories}
                    onChange={this._onChangeCategories}
                    placeholder="Select an option"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* sales type */}
        <div className={`row ${styles['margin-top-30']}`}>
          <div className="col-lg-12">
            <div className="form-group" style={{ marginBottom: 0 }}>
              <div className={`${styles['label-input-sales-type']}`}>
                <span> PRICING </span>
                <Link
                  to="https://mokaposhelp.zendesk.com/hc/id/articles/900000454066-Cara-Membuat-Sales-Type-How-to-Create-Sales-Type"
                  className={styles['link-sales-type']}
                  onClick={this.props.onClickTrackLink}
                  target="_blank"
                >
                  Learn how to apply Sales Type pricing
                </Link>
              </div>
              <div>
                {this._isHaveSalesType() && (
                  <div
                    className={`${styles['apply-item-pricing']} ${
                      styles['basic-pricing']
                    }`}
                  >
                    <label>
                      <Field
                        component="input"
                        type="checkbox"
                        name="is_sales_type_price"
                        onChange={this._onChangeSalesType}
                      />
                      &nbsp;&nbsp; Apply multiple price per sales type
                    </label>
                  </div>
                )}
                <ItemVariant salesType={salesType} />
              </div>
            </div>
          </div>
        </div>

        {/* modifiers filter */}
        <div className={`row ${styles['margin-top-30']}`}>
          <div className="col-lg-12">
            <div className="form-group">
              <label className={`${styles['label-input']}`}>MODIFIER</label>
              <FieldArray
                name="active_modifiers"
                component={ItemModifier}
                modifiers={itemForm.active_modifiers}
              />
            </div>
          </div>
        </div>

        {/* description filter */}
        <div className={`row ${styles['margin-top-30']}`}>
          <div className="col-lg-12">
            <div className="form-group">
              <label className={`${styles['label-input']}`}>Description</label>
              <Field
                component="textarea"
                className="form-control"
                placeholder="Item Description"
                maxLength="70"
                name="description"
                type="text"
                rows="3"
              />
            </div>
          </div>
        </div>

        {/* COGS field */}
        <div className={`row ${styles['margin-top-30']}`}>
          <div className="col-lg-12">
            <div className="form-group">
              <label className={`${styles['label-input']}`}>
                INVENTORY & COST
              </label>
              <div className={styles['item-field-cogs']}>
                <span>
                  This feature is currently only available in outlet level edit.
                  Save item and edit inventory & Cost of Goods Sold (COGS) from
                  each outlet
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  _formatCategories = categories => {
    const formatCategory = [];
    categories.map(function(category) {
      if (category.id > 0) {
        formatCategory.push({ value: category.id, label: category.name });
      }
    });

    return formatCategory;
  };

  _onChangeCategories = (val, newVal) => {
    const { itemDetail } = this.props;
    if (itemDetail && itemDetail.id) {
      if (
        this.props.itemDetail.category.id !== newVal &&
        (this.props.itemDetail.is_point_gain_item ||
          this.props.itemDetail.is_reward_item ||
          this.props.itemDetail.is_point_gain_category_item ||
          this.props.itemDetail.is_reward_category_item)
      ) {
        this.props.itemDetail.categoryChangeMessage =
          "Changing this item's category will affect your loyalty program. Are you sure you want to do this?";
        this.props.itemDetail.categoryChangeTitle = 'Change Item Category';
      } else {
        this.props.itemDetail.categoryChangeMessage = '';
        this.props.itemDetail.categoryChangeTitle = '';
      }
    }
  };

  _isHaveSalesType = () => {
    const { salesType } = this.props;
    return salesType.length > 0;
  };

  _onChangeSalesType = event => {
    const { dispatch, itemForm } = this.props;
    dispatch(onCheckedSalesType(event.target.checked, itemForm));
  };
}

ItemForm.propTypes = {
  onSubmit: PropTypes.func,
  dispatch: PropTypes.func,
};

function mapStateToProps(state) {
  const { salesType } = state.library;
  const { categories, itemDetail } = state.businessLibrary.itemHub;

  return {
    itemDetail,
    categories,
    itemForm: getFormValues('itemHub')(state),
    isDirtyForm: isDirty('modal_item_variants')(state),
    salesType: salesType.salesType,
  };
}

const mapForm = {
  form: 'itemHub',
  touchOnBlur: false,
  touchOnChange: true,
};

export default connect(mapStateToProps)(reduxForm(mapForm)(ItemForm));
